import { CatEmployeeJobModel } from "./cat-employee-job.model";
import { CatProductCategoryModel } from "src/app/model/cat-product-category.model";
import { CatAnchorTypeModel, CatBusinessProductModel, CatProductModel, CatPromotionModel, CatSchemaModel } from "./other-catalogs-models"

export class ComProductEmployeeJobModel {
    public commissionId?:number;
    
    public BusinessProductId?:CatBusinessProductModel;
    public CatAnchorType?:CatAnchorTypeModel;
    public EmployeeJobId?:CatEmployeeJobModel;
    public ProductCategoryId?:CatProductCategoryModel;
    public ProductosCOEId?:CatProductModel;
    public PromotionIdExt?:CatPromotionModel;
    public SchemaId?:CatSchemaModel;
    public afiliateId?:string;
    public commission?:number;
    public paymentId?:number;
    
    public activeId?:boolean;
    public createUserId?:number;
    public createDate?:string;
    public modifUserId?:number;
    public modifDate?:string;
}